import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type VerifyUserMutationVariables = Types.Exact<{
  input: Types.VerifyUserInput;
}>;

export type VerifyUserMutation = {
  __typename?: 'Mutation';
  verifyUser: {
    __typename?: 'VerifyUserResponse';
    message: string;
    otpToken?: string | null;
    success: boolean;
  };
};

export const VerifyUserDocument = gql`
  mutation VerifyUser($input: VerifyUserInput!) {
    verifyUser(input: $input) {
      message
      otpToken
      success
    }
  }
`;
export type VerifyUserMutationFn = Apollo.MutationFunction<
  VerifyUserMutation,
  VerifyUserMutationVariables
>;
export function useVerifyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyUserMutation,
    VerifyUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyUserMutation, VerifyUserMutationVariables>(
    VerifyUserDocument,
    options,
  );
}
export type VerifyUserMutationHookResult = ReturnType<
  typeof useVerifyUserMutation
>;
export type VerifyUserMutationResult =
  Apollo.MutationResult<VerifyUserMutation>;
export type VerifyUserMutationOptions = Apollo.BaseMutationOptions<
  VerifyUserMutation,
  VerifyUserMutationVariables
>;
